/* istanbul ignore file */
import { storageService } from 'framework/utils';
import { useBaseCrudService } from 'framework/crud';
import { useKernelApi } from 'infrastructure/api';
import { AddressType } from 'framework/ui/field';

export const AUSTIN_OFFICE_ID = 1;
export const MINSK_OFFICE_ID = 2;
export const KRAKOW_OFFICE_ID = 3;
export const TBILISI_OFFICE_ID = 4;
const POLISH_OFFICES_ID = [String(KRAKOW_OFFICE_ID)];
export const POLISH_OFFICE_CODES = ['KRAKOW'] as const;

export const isPolishOffice = (officeId: string) => {
  return POLISH_OFFICES_ID.includes(officeId);
};

export const isPolishOfficeCode = (officeCode: string) =>
  POLISH_OFFICE_CODES.includes(officeCode.toUpperCase() as (typeof POLISH_OFFICE_CODES)[number]);

export const isMinskOffice = (officeId: string) => {
  return String(MINSK_OFFICE_ID) === officeId;
};

export const isAustinOffice = (officeId: string) => {
  return String(AUSTIN_OFFICE_ID) === officeId;
};

export const ANYWHERE_OFFICE_NAME = 'Full-Remote';

export const OFFICE_NAMES: { [key: string]: any } = {
  'Austin-1': 'Austin',
  'Minsk-1': 'Minsk',
  'Krakow-1': 'Krakow',
  'Tbilisi-1': 'Tbilisi',
  'Full-Remote': 'Anywhere',
};

export interface OfficeType {
  id: number;
  name: string;
  address: AddressType;
}

const useOfficeService = () => {
  const { findAll: findAllFromApi } = useBaseCrudService({
    listResourceUrl: '/offices',
    singleResourceUrl: '',
    useService: useKernelApi,
  });

  const { getDataFromStorage } = storageService('offices', findAllFromApi, '1.3');

  const getOfficeById = async (id: number): Promise<OfficeType> => {
    const offices = await getDataFromStorage();
    return offices.find((office: { id: any }) => office.id === id) || {};
  };

  return {
    findAll: getDataFromStorage,
    findOfficeById: getOfficeById,
  };
};

export default useOfficeService;
